'use strict';
exports.__esModule = true;
var angular = require("angular");
var config_1 = require("./config");
var login_view_controller_1 = require("./views/login2/login-view.controller");
/**
 * Created by fan on 3/8/18.
 */
require('./app.css');
exports.app = angular.module('smartorg.r6', [
    // Libs
    // 'ngHandsontable',
    'ui.layout',
    'ui.toggle',
    'ngRoute',
    // Main pages
    login_view_controller_1["default"],
    require('./views/azure-login/app/js/plumbing/azure-login.js'),
    require('./views/azure-login-fail/azure-failed.controller.js'),
    require('./views/firstpage/app/js/plumbing/firstpage.js'),
    require('./views/password-reset/app/js/plumbing/password-reset.js'),
    require('./views/workbench/app/js/plumbing/workbench.js'),
]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/verify', {
            controller: 'EmailVerifyCtrl',
            template: require('./verify.html')
        }).when('/verify/:username/:key', {
            controller: 'EmailVerifyCtrl',
            template: require('./verify.html')
        }).otherwise({ redirectTo: '/login' });
    }]).constant("config", {
    "smartorg": new SmartOrg(config_1.BACKEND_DOMAIN, config_1.API_ENDPOINT)
    // The following line is for debug
    // "smartorg": new SmartOrg('http://127.0.0.1:5000', '')
    // "smartorg": new SmartOrg('https://dev.smartorg.com', 'kirk')
    // "smartorg": new SmartOrg('https://stryker-staging.smartorg.com', 'kirk')
    // "smartorg": new SmartOrg('https://training.smartorg.com', 'kirk')
    // "smartorg": new SmartOrg('https://trials.smartorg.com', 'kirk')
}).controller('EmailVerifyCtrl', function ($scope, $routeParams, $window, $timeout, config) {
    var verifyEmail = function () {
        if ($routeParams.username && $routeParams.key) {
            var smartorg_1 = config.smartorg;
            smartorg_1.confirmUserEmail($routeParams.username, $routeParams.key).then(function (result) {
                $scope.verificationResult = result;
                $scope.verifying = false;
                $scope.$apply();
            })["catch"](function (err) {
                $scope.verifying = false;
                console.log(err);
                $window.location.href = "404.html";
            });
        }
    };
    $scope.verifying = true;
    $scope.verificationResult = false;
    $scope.username = $routeParams.username;
    $timeout(verifyEmail);
}).factory('notify', ['$window', function (win) {
        var msgs = [];
        return function (msg) {
            msgs.push(msg);
            if (msgs.length === 3) {
                win.alert(msgs.join('\n'));
                msgs = [];
            }
        };
    }]);
;
// Import version service after module is created
require("./version-service");
require("./pnav-version"); // Load default version
require("./terminology-service"); // Load terminology service
$.ajaxSetup({ cache: false });
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/app.js